document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', function (e) {
        const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
        if (quickViewBtn) {
                let counter = 0;
                let selector = "[bss-b2b-product-form='quickview']"
                const interval = setInterval(() => {
                    let element = document.querySelector(selector);
                    if (element) {
                        console.log("Phần tử đã xuất hiện");
                        clearInterval(interval);

                        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
                        const productForm = document.querySelector('[bss-b2b-product-form="quickview"]');
                        BSS_B2B?.observer?.productSubject?.notifyObserver?.('VariantChange', 'VariantSelectChange', { productForm })
                        console.log("show qb table");

                        
                    } else {
                        counter += 100;
                        if (counter >= 10000) {
                            clearInterval(interval);
                        }
                    }
                }, 100); 

                setTimeout(() => {
                    document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
                    const productForm = document.querySelector('[bss-b2b-product-form="quickview"]');
                    BSS_B2B?.observer?.productSubject?.notifyObserver?.('VariantChange', 'VariantSelectChange', { productForm })
                    console.log("show qb table1");
                    // setTimeout(() => {
                    //     document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
                    //     BSS_B2B?.observer?.productSubject?.notifyObserver?.('VariantChange', 'VariantSelectChange', { productForm })
                    //     console.log("show qb table2");
                    // }, 2000);
                }, 5000);
        }
    });
});

// let counter = 0;
// let selector = ".bss-b2b-qty-table-wrapper"
// const interval = setInterval(() => {
//     let element = document.querySelector(selector);
//     if (element) {
//         console.log("Phần tử đã xuất hiện");
//         clearInterval(interval);

//         const el = document.querySelector('[bss-b2b-main-product-form] .border-radius-left-table-qb');
//         if (el && el.textContent.includes('≥')) {
//             const number = el.textContent.replace(/[^\d]/g, '');
//             el.innerHTML = `<span class="bss-above-text">Above</span> ${number}`;
//         }
//     } else {
//         counter += 100;
//         if (counter >= 10000) {
//             clearInterval(interval);
//         }
//     }
// }, 100); 